<template>
  <a
    v-if="event && xSmallTeaser"
    :href="url"
    class="article-element article-element-x-small px-2"
  >
    <div class="article-element__image">
      <img
        :data-src="`${image}?w=160&h=160&fit=crop&crop=faces&dpr=1`"
        :srcset="`
          ${image}?w=160&h=160&fit=crop&crop=faces&dpr=1 1x,
          ${image}?w=160&h=160&fit=crop&crop=faces&dpr=2 2x`"
        :alt="event.attributes.image.alt"
        :title="event.attributes.image.title"
        data-sizes="160px"
      >
    </div>
    <div class="article-element__content">
      <h3 class="article-element__title">{{ event.attributes.title }}</h3>
      <p class="article-element__text">{{ event.attributes.subtitle }}</p>
    </div>
  </a>
  <div
    v-else-if="event"
    :class="{
      'article-element--text-left': alignLeft,
      'article-element--round': !smallTeaser,
      'article-element-small article-element-small--round': smallTeaser
    }"
    class="article-element"
  >
    <div class="article-element__image">
      <img
        v-if="smallTeaser"
        :data-src="`${image}?w=337&h=337&fit=crop&crop=middle&dpr=1`"
        :data-srcset="`
          ${image}?w=272&h=272&fit=crop&crop=middle&dpr=1 272w,
          ${image}?w=337&h=337&fit=crop&crop=middle&dpr=1 337w,
          ${image}?w=272&h=272&fit=crop&crop=middle&dpr=2 544w,
          ${image}?w=337&h=337&fit=crop&crop=middle&dpr=2 674w`"
        data-sizes="(min-width: 968px) 336px, 272px"
        width="336"
        height="336"
        class="lazy lazyload"
      >
      <picture v-else>
        <source
          :data-srcset="`
            ${image}?w=278&h=278&fit=crop&crop=middle&dpr=1 320w,
            ${image}?w=335&h=335&fit=crop&crop=middle&dpr=1 375w,
            ${image}?w=374&h=374&fit=crop&crop=middle&dpr=1 414w,
            ${image}?w=600&h=600&fit=crop&crop=middle&dpr=1 640w,
            ${image}?w=556&h=556&fit=crop&crop=middle&dpr=2 640w,
            ${image}?w=670&h=670&fit=crop&crop=middle&dpr=2 750w,
            ${image}?w=748&h=748&fit=crop&crop=middle&dpr=2 818w,
            ${image}?w=1200&h=1200&fit=crop&crop=middle&dpr=2 1280w'
          `"
          media="(max-width: 768px)"
        >
        <source
          :data-srcset="`
            ${image}?w=450&h=450&fit=crop&crop=middle&dpr=1 450w,
            ${image}?w=816&h=816&fit=crop&crop=middle&dpr=1 968w,
            ${image}?w=900&h=900&fit=crop&crop=middle&dpr=2 900w,
            ${image}?w=1623&h=1623&fit=crop&crop=middle&dpr=2 1936w
          `"
        >
        <img
          :data-src="`${image}?w=816&h=816&fit=crop&crop'=middle&dpr=1`"
          :title="event.attributes.image.title"
          :alt="event.attributes.image.alt"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          class="lazy lazyload bg-light"
        >
      </picture>
    </div>
    <div class="article-element__content">
      <div class="article-element__subtitle">
        {{ event.attributes.category }}: {{ event.attributes.location }}
      </div>
      <h3 class="article-element__title">
        {{ event.attributes.title }}
      </h3>
      <p class="article-element__text">
        {{ event.attributes.subtitle }}
      </p>
      <a
        v-if="!smallTeaser"
        :href="url"
        class="button"
      >
        Mehr erfahren
      </a>
      <a
        v-else
        :href="url"
        class="button button-compact"
      >
        <icon name="chevron-right" />
      </a>
    </div>
  </div>
</template>

<script>
import { Icon } from 'zv-components'
import axios from 'axios'

export default {
  name: 'EventTeaser',
  components: { Icon },
  props: {
    uid: {
      type: String,
      required: true,
    },
    baseUrl: {
      type: String,
      default: '/',
    },
    alignLeft: {
      type: Boolean,
      default: false,
    },
    smallTeaser: {
      type: Boolean,
      default: false,
    },
    xSmallTeaser: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      event: null,
    }
  },

  computed: {
    url () {
      if (this.event) {
        return this.baseUrl + this.event.attributes.slug
      }

      return null
    },
    image () {
      return this.event.attributes.image.url
    },
  },

  mounted () {
    axios({
      method: 'get',
      url: `${globalConfigs.events.api_base}event/teaser/${this.uid}`,
      headers: {
        'Accept': 'application/json',
        'X-ZV-TOKEN': globalConfigs.events.key,
      },
    }).then(({ data }) => {
      this.event = data.data
    }).catch(() => {
      console.warn('Error while requesting event details.')
    })
  },
}
</script>
